import { FC } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { ConfirmDialogContent } from './components/confirmDialogContent/ConfirmDialogContent'
import { TConfirmDialogProps } from './models'

import styles from './ConfirmDialog.module.scss'

export const ConfirmDialog: FC<TConfirmDialogProps> = ({ isVisible, size = 'sm', ...props }) => {
  return (
    <ModalDialog
      classes={{ window: styles.window }}
      content={ConfirmDialogContent}
      onClose={() => undefined}
      contentProps={props}
      show={isVisible}
      size={size}
      closeOnOutsideClick={false}
    />
  )
}
